import excel from "@/utils/excel";
import common from '@/common.js';

export default class downloadExcel {
    list1 = [];
    list3 = [];
    columns1 = [];
    columns3 = [];
    base = 5;
    colorList = {
        "1": "fac006",
        "2": "91ce51",
        "3": "02aeef",
    };
    mergsList = [];
    lineGroup = [];
    dataInfo = {};
    constructor(list1, list3, columns1, columns3, lineGroup, info) {
        this.list1 = list1;
        this.list3 = list3;
        this.columns1 = columns1.map(i => {
            return {
                ...i,
                label: i.title,
                id: i.key,
            }
        });
        this.columns3 = columns3.map(i => {
            return {
                ...i,
                label: i.title,
                id: i.key,
            }
        });
        this.lineGroup = lineGroup;
        this.dataInfo = JSON.parse(info.returnJson);
        this.info = info;
        this.columns = [...this.columns1, { label: "", id: "" }, ...this.columns3];
    }
    download = (list) => {
        let newList = this.formatTableData();
        let merge = this.getMerges();
        let colors = this.getColors();
        let borders = this.getBorders();
        let pathData = this.getPath(); //处理链路

        let tableData = [[], ...pathData, []];
        let ydxData = this.getYdx(tableData.length + newList.length); //易读性
        tableData = [...tableData, ...ydxData.list];

        let fileTitle = "症状辨证推理";
        let exceptionMedicalRecord = this.dataInfo.exceptionMedicalRecord
            ? "分析异常：" + this.dataInfo.exceptionMedicalRecord
            : "";
        // let title = `${symptomList.value}\n\n${exceptionMedicalRecord}`;
        let title = `${exceptionMedicalRecord}`;
        let titleHeight = 80;
        titleHeight = 120;
        let dialecticalData = this.dataInfo;
        let explainTypeStr = "";
        if (dialecticalData.explainType) {
            explainTypeStr = "需要讲解病因病机";
        } else if (dialecticalData.explainType !== null) {
            explainTypeStr = "不需要讲解病因病机";
        }
        let arr = [
            `分析结果 ${this.info.patientName} ${this.info.diagnosticName2} ${this.info.updDtString}`,
            `${explainTypeStr}`,
            `${dialecticalData.explainTitle || ""}`,
            `${dialecticalData.explainContent || ""}`,
            `未关联辨证的症状：${this.getNoRelationSymptomName()}`,
            `结论：${dialecticalData.conclusion || "无"}`,
        ];
        title = arr.join("\n");

        merge.push(
            ...[
                [2, 1, 2, 3],
                [2, 4, 2, 6],
                [2, 7, 2, 9],
            ],
            ...ydxData.merge
        );

        excel(fileTitle, [
            {
                autoHeight: true,
                textAling: "left",
                widths: [
                    30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30,
                    30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30,
                ],
                title,
                titleHeight,
                list: newList,
                merge,
                colors,
                borders,
                headerOtherInfo: {
                    data: [
                        [],
                        [
                            "黄色背景：症状对应唯一的辨证",
                            "",
                            "",
                            "绿色背景：串联链路中症状对应的非唯一辨证",
                            "",
                            "",
                            "蓝色背景：单独线路中内因或外因导致的辨证",
                            "",
                            "",
                        ],
                    ],
                },
                afterData: {
                    data: tableData,
                },
                callback: (ws) => {
                    //添加颜色解说文字背景
                    const row = ws.getRow(2);
                    row.height = 15;
                    this.columns.forEach((item, index) => {
                        let key = 1;
                        if (index >= 0 && index < 3) {
                            key = 1;
                        } else if (index >= 3 && index < 6) {
                            key = 2;
                        } else if (index >= 6 && index < 10) {
                            key = 3;
                        }

                        let argb = this.colorList[key];
                        let node = row.getCell(index + 1);
                        node.font = {
                            size: 13,
                        };
                        node.fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: {
                                argb,
                            },
                            bgColor: {
                                argb,
                            },
                        };
                    });
                },
            },
        ]);
    }

    getNoRelationSymptomName = () => {
        let list = this.dataInfo.etiologyDialecticalVOS;
        return list ? (list.length ? list[0].noRelationSymptomName : "无") : "无";
    };

    getBorders = () => {
        let baseIndex = this.base - 1;
        let obj = {};
        let l1 = [...this.list1, ""];
        l1.forEach((row, rowIndex) => {
            this.columns1.forEach((column) => {
                obj[`${rowIndex + baseIndex}-${column.label}`] = 1;
            });
        });

        let l3 = [...this.list3, ""];
        l3.forEach((row, rowIndex) => {
            this.columns3.forEach((column) => {
                obj[`${rowIndex + baseIndex}-${column.label}`] = 1;
            });
        });
        return obj;
    };

    getColors = () => {
        let obj = {};
        let l1 = this.list1;
        this.mergsList.forEach((row, rowIndex) => {
            [...this.columns1, ...this.columns3].forEach(
                (column, columnIndex) => {
                    if (column.label == "典型" && row.onlyOneDx) {
                        obj[`${rowIndex + this.base}-${column.label}`] = {
                            bg: this.colorList[row.onlyOneDx],
                        };
                    } else if (column.label == "非典型" && row.onlyOneFdx) {
                        obj[`${rowIndex + this.base}-${column.label}`] = {
                            bg: this.colorList[row.onlyOneFdx],
                        };
                    } else {
                        obj[`${rowIndex + this.base}-${column.label}`] = {
                            bg: this.colorList[row[column.label + "onlyOne"]],
                        };
                    }
                }
            );
        });
        return obj;
    };

    getMerges = () => {
        let l1 = this.list1;
        if (l1.length === 0) {
            return [];
        }
        let dsName = l1[0].dsName;
        let mergs = [];
        let merg = [this.base, 1];
        l1.forEach((item, index) => {
            if (item.dsName != dsName) {
                merg.push(index + this.base - 1, 1);
                mergs.push(common.clone(merg));
                merg = [index + this.base, 1];
                dsName = item.dsName;
            }
        });
        merg.push(l1.length + this.base - 1, 1);
        mergs.push(common.clone(merg));

        let arr = [];
        mergs.forEach((m) => {
            [4, 7].forEach((item) => {
                arr.push([m[0], item, m[2], item]);
            });
        });
        mergs = [...mergs, ...arr];

        return mergs;
    };

    formatTableData = () => {
        let l1 = this.list1;
        let l2 = this.list3;
        let length = Math.max(l1.length, l2.length);
        let newList1 = [];
        let newList2 = [];
        for (let i = 0; i < length; i++) {
            let row = l1[i] ? { ...l1[i] } : {};
            if (l2[i]) {
                row = { ...row, ...l2[i] };
            }
            newList1.push(row);
        }
        this.mergsList = newList1;

        newList2 = newList1.map((i) => {
            let obj = {};
            this.columns.forEach((item) => {
                obj[item.label] = i[item.id];
            });
            return obj;
        });
        return newList2;
    };



    getPath = () => {
        let arr = [];
        this.lineGroup?.forEach((item, index) => {
            arr.push([`线路${item.id}`]);
            let l = [];
            item.list.forEach((j) => {
                let dialecticName = (j.transOrder || "") + j.dialecticName;
                let pathogenesisList = "";
                if (j.pathogenesisList && j.pathogenesisList.length) {
                    pathogenesisList = j.pathogenesisList.join("\n");
                    dialecticName += "➸";
                }
                let s = l.length == 0 ? "" : "➸";
                l.push(s + dialecticName);
                pathogenesisList && l.push(pathogenesisList);
            });
            arr.push(l);
        });
        return arr;
    };

    getYdx = (startIndex) => {
        startIndex = startIndex + this.base;
        let arr = [];
        this.dataInfo.easyCausePathogenesisList?.forEach((item, g_index) => {
            arr.push([`线路${item.group.replace(/,/g, "、")}`]);
            item.easyCausePathogenesis.forEach((j, index) => {
                arr.push([j]);
                arr.push(["(提示：病因是概括性的，请根据实际情况选择说明)"]);
            });
        });
        let merge = arr.map((item, index) => {
            return [startIndex + index, 1, startIndex + index, 11];
        });
        return {
            list: arr,
            merge,
        };
    };
}